<template>
	<div v-if="value">
		<BaseHeader :title="getTitle" />
		<div class="px-8 grid grid-cols-1 md:grid-cols-2 gap-x-4 tr mt-8">
			<BaseInput :label="$t('company')" ref="BaseInput.company.name" v-model="value.name" :disabled="true" />
			<BaseInput :label="$t('tax_number')" ref="BaseInput.company.taxNumber" v-model="value.taxNumber" :disabled="true" />
			<div class="flex space-x-4">
				<BaseInput class="w-1/2" :label="$t('owner_first_name')" ref="BaseInput.company.vorname" v-model="value.ownerFirstname" :disabled="true" />
				<BaseInput class="w-1/2" :label="$t('owner_last_name')" ref="BaseInput.company.nachname" v-model="value.ownerLastname" :disabled="true" />
			</div>
			<div class="flex">
				<BaseInput :label="$t('street')" ref="BaseInput.company.street" v-model="value.street" class="w-full mr-2" :disabled="true" />
				<BaseInput :label="$t('number')" ref="BaseInput.company.houseNumber" v-model="value.houseNumber" :disabled="true" />
			</div>
			<CityInput ref="CityInput" v-model="value.city" :disabled="true" />
			<div class="flex w-full space-x-4">
				<BaseInput class="w-full" :label="$t('phone')" ref="BaseInput.company.phoneNumber" :disabled="true" v-model="value.phoneNumber" />
				<BaseInput class="w-full" :label="$t('mobile_number')" ref="BaseInput.company.mobileNumber" v-model="value.mobileNumber" :disabled="true" />
			</div>

			<BaseInput :label="$t('first_e_mail_address')" ref="BaseInput.company.email" v-model="value.email" :disabled="true" />
			<BaseInput :label="$t('second_e_mail_address')" ref="BaseInput.company.secondEmail" v-model="value.secondEmail" :disabled="true" />
			<BaseInput :label="$t('homepage')" ref="BaseInput.company.homepage" v-model="value.homepage" :disabled="true" />
			<BaseInput :label="$t('company_head_quarter')" ref="BaseInput.company.firmensitz" v-model="value.firmensitz" :disabled="true" />
		</div>

		<Footer @backButtonClick="$router.go(-1)" class="mx-8" :is-continue-button="false"> </Footer>
	</div>
</template>

<script>
import { CompanyApiFactory } from '@/api/generated';
import apiDefaults from '@/api/defaultConfiguration';
import BaseHeader from '@/components/navigation/BaseHeader';
import BaseInput from '@/components/forms/inputs/BaseInput';
import CityInput from '@/components/forms/CityInput';
import Validate from '@/mixins/Validate';
import Footer from '@/components/damagecases/Footer.vue';
import Authentication from '@/mixins/Authentication';

export default {
	name: 'EditCompany',
	components: { CityInput, BaseInput, BaseHeader, Footer },
	mixins: [Validate, Authentication],
	data() {
		return {
			damageAssessorsOptions: null,
			damageAssessors: null,
			selectedDamageAssessors: null,
			value: {
				bankAccount: {},
				city: {},
			},
			companyType: 'Firma',
		};
	},
	methods: {
		setSelectedPostal(event) {
			this.selectedPostalOption = event;
		},
		setCompanyType() {
			switch (this.$route.params.type) {
				case 'repairShop':
					this.companyType = this.$t('repair_shop');
					break;
				case 'car_dealership':
					this.companyType = this.$t('car_shop');
					break;
			}
		},
		getCompanyProfileData(id) {
			return CompanyApiFactory(apiDefaults.config(), apiDefaults.basePath, apiDefaults.axios)
				.companyIdGet(id)
				.then(response => {
					this.value = response.data;
				})
				.catch(error => {});
		},
	},
	mounted() {
		this.getCompanyProfileData(this.$route.params?.id);
		this.setCompanyType();
	},
	computed: {
		getType() {
			return this.type || this.$route.params.type;
		},
		getTitle() {
			return this.companyType;
		},
		getAuthenticatedUserGroupLevel() {
			return this.$store.getters.getAuthenticatedUserGroupLevel;
		},
	},
};
</script>

<style scoped></style>
